import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ChildrenItem from './ChildrenItem';
import { moveElementPosition } from '../../../../utils/splices';

import { CHILDREN } from '../../../../constants/literals/modals';

/**
 * Import styles
 */
import { StyledBoxDown, StyledButton, StyledButtonPlus } from './style';

import { StyledModal } from './styleEducation';

class Children extends Component {
  constructor(props) {
    super(props);

    const data = props.dataChildren.map(item => ({
      ...item
    }));

    this.state = {
      data,
      dataChildrenFormatted: data,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickExpand(index) {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = {
      ...clonedData[index],
      expanded: !clonedData[index].expanded
    };

    this.setState({ data: clonedData });
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataChildrenFormatted } = this.state;

    return _.isEqual(dataChildrenFormatted, data);
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const error = this.hasErrors();
    if (error) {
      this.setState({
        data: data.map(item => ({
          ...item
        }))
      });
    } else {
      onAcceptModal(data);
    }
  };

  handleChange = (value, index, key) => {
    const { data } = this.state;
    const clonedData = [...data];
    clonedData[index] = { ...clonedData[index], [key]: value };
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      name: '',
      surname: '',
      birthdate: ''
    });
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  hasErrors() {
    const { data } = this.state;
    const dataErrors = [...data];
    let hasErrors = false;

    // eslint-disable-next-line guard-for-in
    for (const x in data) {
      if (!dataErrors[x].name) {
        dataErrors[x].errorName = 'El campo nombre es obligatorio';
        hasErrors = true;
      } else {
        dataErrors[x].errorName = null;
      }
      if (!dataErrors[x].surname) {
        dataErrors[x].errorSurname = 'El campo apellidos es obligatorio';
        hasErrors = true;
      } else {
        dataErrors[x].errorSurname = null;
      }
      if (!dataErrors[x].birthdate) {
        dataErrors[x].errorBirthdate =
          'El campo fecha de nacimiento es obligatorio';
        hasErrors = true;
      } else {
        dataErrors[x].errorBirthdate = null;
      }
    }
    this.setState({
      data: dataErrors
    });
    return hasErrors;
  }

  render() {
    const { onCloseModal, formUser } = this.props;
    const { data, btnIsDisabled } = this.state;

    return (
      <StyledModal
        title={CHILDREN.TITLE}
        clickCloseIcon={onCloseModal}
        tabletSize
      >
        {data.map((item, index) => (
          <ChildrenItem
            formUser={formUser}
            key={`${item.startDate}${index + 1}`}
            expanded={item.expanded}
            order={index + 1}
            name={item.name}
            surname={item.surname}
            birthdate={item.birthdate}
            onChangeNameInput={e => this.handleChange(e, index, 'name')}
            onChangeSurnameInput={e => {
              this.handleChange(e, index, 'surname');
            }}
            onChangeBirthdateInput={e => {
              this.handleChange(e, index, 'birthdate');
            }}
            onClickExpand={() => this.onClickExpand(index)}
            onClickDelete={() => this.onClickDelete(index)}
            onClickDown={() => this.onClickOrderArrow(index, true)}
            onClickUp={() => this.onClickOrderArrow(index, false)}
            errorName={item.errorName}
            errorSurname={item.errorSurname}
            errorBirthDate={item.errorBirthdate}
          />
        ))}
        <StyledButtonPlus dark onClick={this.handlePlus} tabletSize />
        <StyledBoxDown>
          <StyledButton onClick={onCloseModal} modal>
            {CHILDREN.CANCEL}
          </StyledButton>
          <StyledButton
            onClick={this.handleAccept}
            secondary
            disabled={btnIsDisabled}
          >
            {CHILDREN.ACCEPT}
          </StyledButton>
        </StyledBoxDown>
      </StyledModal>
    );
  }
}

Children.propTypes = {
  dataChildren: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      surname: PropTypes.string,
      birthdate: PropTypes.string //  date: PropTypes.instanceOf(Date),
    })
  ),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  formUser: PropTypes.bool
};

Children.defaultProps = {
  dataChildren: [],
  formUser: false
};

export default Children;
